var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.scrollTop > 200)?_c('div',{staticClass:"back-to-top",on:{"click":_vm.backToTop}},[_c('img',{attrs:{"src":"https://oss.hzwohu.com/assets/icon/back.png","alt":""}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }